
import request from '@/utils/request'

// tbox数据
export function GetTboxdata (data) {
  return request({
    url: '/car/tbox/data',
    method: 'post',
    data
  })
}
// 新增
export function addTbox (data) {
  return request({
    url: '/car/tbox/add',
    method: 'post',
    data
  })
}
//编辑
export function updateTbox (data) {
  return request({
    url: '/car/tbox/updateTbox',
    method: 'post',
    data
  })
}
// 车辆品牌下拉框
export function dataSelectBrand (data) {
  return request({
    url: '/car/tbox/dataSelectBrand ',
    method: 'post',
    data
  })
}
// 车辆型号下拉框
export function dataSelectType (data) {
  return request({
    url: '/car/tbox/dataSelectType',
    method: 'post',
    data
  })
}

// 车辆型号下拉框
export function dataSelectModel (params) {
  return request({
    url: '/car/tbox/dataSelectModel',
    method: 'post',
    params
  })
}
// 车架号
export function dataSelectCarNum (data) {
  return request({
    url: '/car/tbox/dataSelectCarNum',
    method: 'post',
    data
  })
}

// 厂家
export function dataSelectFactory (data) {
  return request({
    url: '/car/tbox/dataSelectFactory',
    method: 'post',
    data
  })
}
// 详情数据
export function dataSelectTbox (data) {
  return request({
    url: '/car/tbox/dataSelectTbox ',
    method: 'post',
    data
  })
}
// 获取排序方式列表
export function GetSortList () {
  return request({
    url: '/car/tbox/sortList',
    method: 'post'
  })
}


// 获取未绑定的tbox数据列表
export function unBindData (data) {
  return request({
    url: '/car/tbox/unBindData',
    method: 'post',
    data
  })
}

// 删除tbox数据
export function delData (data) {
  return request({
    url: '/car/tbox/delete',
    method: 'post',
    data
  })
}
// 查询公司列表
export function getCarCompanyList () {
  return request({
    url: '/car/tbox/getCompanys',
    method: 'get'
  })
}